import { Component } from 'react'
import { connect } from 'react-redux'
import { Container, Loader } from '../../cdl-react-components/components'
import ContentGroups from '../../Utilities/ContentGroups'
import EPAnalysis from '../../Utilities/EPAnalysis'
import RecentActivityMap from '../../Utilities/RecentActivityMap'
import RecentArticles from '../../Utilities/RecentArticles'
import FeaturedArticles from '../../Utilities/FeaturedArticles'
import ActivitySummaryBanner from '../../Utilities/ActivitySummaryBanner'
import CrownLandButton from '../../Utilities/CrownLandButton'

class Front extends Component {

    render() {
        const { recentArticles, contentGroups, featuredArticles, recentActivityMap } = this.props
        const loaded = !!recentArticles && !!contentGroups && !!featuredArticles && !!recentActivityMap

        return (
            <Container id="front-page">
                <div className={loaded ? '' : 'front-page__hidden'}>
                    <RecentArticles />
                    <EPAnalysis />
                </div>
                <div className={loaded ? '' : 'front-page__hidden'}>
                    <ContentGroups />
                    <ActivitySummaryBanner />
                    <CrownLandButton />
                    {/* <RegionalMapButton /> */}
                    <RecentActivityMap />
                    <FeaturedArticles />
                </div>
                { !loaded && <Loader /> }
            </Container>
        )
    }
}

const mapStateToProps = ({ data }) => ({ 
    recentArticles: data.configuration.recentArticles,
    epAnalysis: data.configuration.epAnalysis,
    contentGroups: data.configuration.contentGroups,
    featuredArticles: data.configuration.featuredArticles,
    recentActivityMap: data.configuration.recentActivityMap
})

export default connect(mapStateToProps)(Front)
